import SEO from "@/components/SEO";
import { PageHero, LegalDoc } from "@/components/Bits";
import { HEALTHCARE } from "@/content/policies";

export default function HealthcareNotice() {
  return (
    <div data-testid="healthcare-notice-page">
      <SEO
        title="Healthcare & Medical Product Notice"
        description="Middle Man is not a doctor, pharmacy or emergency provider. Current catalog is limited to permitted first-aid, wellness, hygiene and OTC-type products; prescription medicines are excluded."
        path="/healthcare-notice"
      />
      <PageHero
        kicker="Policies"
        title="Healthcare & Medical Product Notice"
        subtitle="Effective from: 11 September 2026 · Please read before buying any health-related product on Middle Man."
      />
      <LegalDoc doc={HEALTHCARE} />
    </div>
  );
}
